import React, { useCallback, useState } from 'react';
import { format } from 'date-fns';
import classNames from 'classnames';
import { Field } from 'formik';
import { Calendar } from 'react-date-range';
import CalendarSelect from './calendarSelect/CalendarSelect';

import { useClickOutside } from '../../hooks/useClickOutside';

import { ReactComponent as CalendarIcon } from './calendar.svg';

import '../../../node_modules/react-date-range/dist/styles.css';
import '../../../node_modules/react-date-range/dist/theme/default.css';
import './Calendar.css';

const today = new Date();

const MyCalendar = ({ name, touched, errors, values, setValues }) => {
    const [calendarIsOpen, setCalendarIsOpen] = useState(false);
    const [chosenDate, setChosenDate] = useState(null);

    const domNode = useClickOutside(() => {
        setCalendarIsOpen(false);
    });

    const handleToggle = useCallback(() => {
        setCalendarIsOpen(!calendarIsOpen);
    }, [calendarIsOpen]);

    const handleSelect = useCallback(
        date => {
            setChosenDate(date);
            setValues(prevValues => ({
                ...prevValues,
                [name]: date,
            }));
            setCalendarIsOpen(false);
        },
        [values, calendarIsOpen, chosenDate]
    );

    const calendarHeaderClass = classNames({
        'calendar-header': true,
        'field-error': errors[name] && touched[name] && !calendarIsOpen,
    });

    const calendarContainerClass = classNames({
        'calendar-container': true,
        hidden: !calendarIsOpen,
    });

    return (
        <div className="calendar-wrap dropDownContainer" ref={domNode}>
            <div className={calendarHeaderClass} onClick={handleToggle}>
                <CalendarIcon />
                <Field as={CalendarSelect} name={name} values={values} chosenDate={values[name] ? format(values[name], 'dd MMMM yyyy') : ''} />
            </div>
            {calendarIsOpen && (
                <div className={calendarContainerClass}>
                    <Calendar
                        date={chosenDate}
                        minDate={today}
                        onChange={handleSelect}
                    />
                </div>
            )}
        </div>
    );
};

export default MyCalendar;
